// extracted by mini-css-extract-plugin
export default {"root":"AmityUSPHighlight_root__LB8jv","body":"AmityUSPHighlight_body__TB-ZZ"};